module.exports = __webpack_public_path__ + "static/media/party-popper.15ad95ff.png";